import { createAsyncThunk } from "@reduxjs/toolkit";
import server from "../middleware/interceptor";

export const startPayment = createAsyncThunk(
  "payments/start",
  async (requestBody: any, { rejectWithValue }) => {
    try {
      const response = await server.post(`/payment/start`, requestBody, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const capturePaypalPayment = createAsyncThunk(
    "payments/complete",
    async (requestBody: any, { rejectWithValue }) => {
      try {
        const response = await server.post(`/payment/paypal/return`, requestBody, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || "Something went wrong");
      }
    }
  );

  export const cancelPaypalPayment=createAsyncThunk(
    "payments/cancel",
    async(token:any,{rejectWithValue})=>{
      try{
        const response = await server.get(`/payment/paypal/cancel?token=${token}`, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        return response.data;
      }catch (error:any){
        return rejectWithValue(error.response?.data || "Something went wrong");
      }
    }
  )